import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, AuthState } from '../../types';

const initialState: AuthState = {
  // DESENVOLVIMENTO: Simulando usuário logado para facilitar testes
  user: {
    id: 'dev-user-1',
    auth_id: 'dev-auth-1',
    email: 'admin@plataforma.dev',
    full_name: 'Admin Desenvolvimento',
    role: 'admin',
    avatar_url: undefined,
    is_active: true,
    last_login_at: new Date(),
    created_at: new Date(),
    updated_at: new Date(),
  },
  token: 'dev-token-123', // Token fictício para desenvolvimento
  isAuthenticated: true, // Forçado como true para desenvolvimento
  isLoading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    loginSuccess: (state, action: PayloadAction<{ user: User; token: string }>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.isLoading = false;
      localStorage.setItem('token', action.payload.token);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      localStorage.removeItem('token');
    },
    updateProfile: (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
    clearError: (state) => {
      state.isLoading = false;
    },
  },
});

export const { setLoading, loginSuccess, logout, updateProfile, clearError } = authSlice.actions;
export default authSlice.reducer; 